(() => {
  const lockVideo = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    const applyMute = () => {
      if (!video.muted) video.muted = true;
      if (video.volume !== 0) video.volume = 0;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
    };
    applyMute();
    if (video.dataset.osteaneMutedLock === 'true') return;
    video.dataset.osteaneMutedLock = 'true';
    video.addEventListener('volumechange', applyMute, true);
    video.addEventListener('play', applyMute, true);
    video.addEventListener('loadedmetadata', applyMute, true);
  };

  const lockIframe = (iframe) => {
    if (!(iframe instanceof HTMLIFrameElement) || !iframe.src) return;
    let url;
    try {
      url = new URL(iframe.src, window.location.href);
    } catch {
      return;
    }
    const host = url.hostname.toLowerCase();
    const isYouTube = host.includes('youtube.com') || host.includes('youtube-nocookie.com') || host === 'youtu.be';
    const isVimeo = host.includes('vimeo.com');
    if (!isYouTube && !isVimeo) return;
    if (isYouTube) {
      url.searchParams.set('mute', '1');
      url.searchParams.set('controls', '0');
      url.searchParams.set('playsinline', '1');
    }
    if (isVimeo) {
      url.searchParams.set('muted', '1');
      url.searchParams.set('controls', '0');
    }
    const nextSrc = url.toString();
    if (iframe.src !== nextSrc) iframe.src = nextSrc;
  };

  const scan = (root) => {
    if (!root) return;
    if (root instanceof HTMLVideoElement) lockVideo(root);
    if (root instanceof HTMLIFrameElement) lockIframe(root);
    if (root.querySelectorAll) {
      root.querySelectorAll('video').forEach(lockVideo);
      root.querySelectorAll('iframe').forEach(lockIframe);
    }
  };

  const start = () => {
    scan(document);
    new MutationObserver((mutations) => {
      mutations.forEach((mutation) => {
        mutation.addedNodes.forEach((node) => {
          if (node instanceof Element) scan(node);
        });
      });
    }).observe(document.documentElement, { childList: true, subtree: true });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start, { once: true });
  } else {
    start();
  }

  document.addEventListener('shopify:section:load', (event) => scan(event.target));
})();